import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import EducationalPageComponent from '../../components/EducationalPageComponent/EducationalPageComponent';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import BrochurePageComponent from '../../components/BrochurePage/BrochurePageComponent';
import { ReactComponent as LineSmallSvgNew } from '../../assets/crissCrossSmallNew.svg';
import css from './inclusuionpage.module.css';
const HeadingTextMob = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.showForMob}`}>
      Inspire growth, confidence, and
      {/* <br /> */}
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>connection</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin.
      </div>
    </p>
  );
};

const HeaderText = () => {
  return (
    <p className={`${css.firstHeaderTop} ${css.hideForMob}`}>
      Inspire growth, confidence, and
      {/* <br /> */}
      <span className={css.tiltedHeighlight}>
        {' '}
        <span className={css.innerTiltText}>connection</span>
      </span>{' '}
      — we’ll handle the{' '}
      <div className={css.headerStyle}>
        <LineSmallSvgNew className={`${css.lineSvg}`} />
        admin.
      </div>
    </p>
  );
};

const Inclusion = props => {
  const { isAuthenticated, currentUser } = props;
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const pageDescription = `Whether you run sensory-friendly play sessions, yoga and sports camps, or inclusive arts and music classes — if you’re helping children (or adults) feel confident, capable and included, we’re here to take care of the admin behind the scenes. From registrations and payments to attendee lists and reminders, Activity Time keeps everything organised so you can focus on what matters — creating welcoming spaces where every child can thrive.`;
  return (
    <Page>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <BrochurePageComponent
            isAuthenticated={isAuthenticated}
            isProvider={isProvider}
            headingText={<HeaderText />}
            headingTextMob={<HeadingTextMob />}
            pageName="Inclusive"
            pageDescription={pageDescription}
            pageBannerImg={`inclusive_bannerImg.png`}
            secondSecTitle={
              'Your admin-loving assistant — calm, capable and never in need of sleep!'
            }
            secondSecSubTitle={
              'Inclusive activity software that keeps your behind-the-scenes admin running smoothly — every time.'
            }
            secondSecMainPic={'inclusive_secondMain.png'}
            secondSecLogo={'inclusive_secondLogo.png'}
            secondSecName={'Emma'}
            secondSecNameDes={'Sensory Play & Movement Classes'}
            secondSecDesc={`“I used to manage class bookings through WhatsApp, Excel and Revolut.
I looked at other options but love Activity Time. Its simple, gives me my own shopfront, automates my bookings and emails plus tracks payments and attendees. Affordable and time-saving.”`}
            secondSecSub={'Let’s make inclusive experiences '}
            thirdSecFirstTitle={`You create the calm — we’ll keep it organised.`}
            thirdSecSecondTitle={`Stay focused on every connection that matters.`}
            thirdSecFirstPic={`inclusive_thirdFirst.png`}
            thierdSecSecondPic={`inclusive_thirdSecond.png`}
            thirdSecParaText={`We know the real progress happens in the moments — not in the paperwork.`}
            testimonialPic={`inclusive_testiminialImg.png`}
            testimonialTitle={`Maya, Inclusive Yoga Classes`}
            testimonialDesc={`“Before Activity Time, I spent evenings chasing messages, checking lists and payments. Now, I always get paid in full and do all admin in minutes. It’s been a huge relief — simple and easy.”`}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <div className={css.footerWrapper}>
            <Footer hideFirstWave={true} />
          </div>
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUserListing, currentUserListingFetched, currentUser } = state.user;
  const { isAuthenticated } = state.Auth || {};

  return {
    currentUserListing,
    currentUserListingFetched,
    currentUser,
    isAuthenticated,
  };
};

export default compose(withRouter, connect(mapStateToProps), injectIntl)(Inclusion);
